import React, { Component } from 'react'
import { connect } from 'react-redux'
import utils from '../lib/utils'
import PageNotFound from './PageNotFound'

import Collection from './Collection'
import Single from './Single'

@connect((state, { match }) => {
  const section = utils.sectionKey(match.url)
  const type = state[section].find(v => v.slug === match.params.type)

  return {section, type}
})
export default class Type extends Component {
  render () {
    const {section, type} = this.props

    if (!type) {
      return <PageNotFound />
    }

    if (type.collection || section === 'roles') {
      return <Collection section={section} type={type} />
    } else {
      return <Single type={type} />
    }
  }
}



// WEBPACK FOOTER //
// ./app/containers/Type.js